import Vue from 'vue';
import api from "../../assets/api";
import moment from "moment";


const replaceCase = (str, key = '', terms) => {
    if(!str) return str; 
  
    // Regex matches the key with a word boundary
    let rx = new RegExp(`\\b${key}\\b`, 'gi');
  
    const match = str.toLowerCase().match(rx) ?? [];
    if(!match.length) return str;
  
    return str.replace(rx, (match) => {
        
        let replacement = terms[match.toLowerCase()];
        if(!replacement) return match;
        // Check if first word is capitalized. If its lower case, then all words should be lower case
        let is_first_upper = match.charAt(0) === match.charAt(0).toUpperCase();
    
        if(!is_first_upper) return replacement.toLowerCase();
  
        // Check if any of the other words are lower case, if so, just capitalize the first word. 
        let has_lower_case = match.split(' ').find(m => m.charAt(0) !== m.charAt(0).toUpperCase());
        
        if(has_lower_case){
          return String(replacement).charAt(0).toUpperCase() + String(replacement).slice(1)
        }
  
        // Check if the entire match is upper case.  If so, upper case the entire replacement
        if(match === match.toUpperCase()){
          return replacement.toUpperCase()
        }
        
        // If no other conditions are met, the first character of each word should be capitalized.
        return replacement.split(' ').map(m => String(m).charAt(0).toUpperCase() + String(m).slice(1)).join(' ');
        
    });
}


 

class Localization {
	constructor() {
        this.namespaced = true;
		this.state = {
            localization: {
                terms: {},
                numbers: {}, 
                dates: {}, 
                countries: [],
                flags: [],
                disabled_tokens: [],
            },
            locales: [],
            locale_id: '',

        }
        
        this.getters = {
            toLocal: (state) => (str) => {             
                let keys = Object.keys(state.localization.terms);
                for(let i = 0 ; i < keys.length; i++){ 
                    str = replaceCase(str, keys[i], state.localization.terms); 
                }
                return str
            },
            toLocalDate: (state) => (str) => {
                let dateFormatMatch = state.localization.dates[str]; 
                return dateFormatMatch;
                /*
                switch(format){
                    default:
                        return moment(str).format(state.localization.dates.default);
                }
                */
            },
            toLocalNum: (state) => (str) => { 
                
            },
            getPhoneCodes: state => {
                let countries = state.localization.countries;
                let codesArray = [];

                countries.forEach( c => {
                    codesArray.push(c.code);
                });
                return codesArray
            },
            getCountryNames: state => {
                let countries = state.localization.countries;
                let countriesArray = [];

                countries.forEach( c => {
                    countriesArray.push(c.country);
                });
                return countriesArray
            },
            getCountries: state => {
                return state.localization.countries
            },
            getLocales: state => {
                return state.locales
            },
            getLocaleId: state => {
                return state.locale_id
            },
            getFlag: (state) => (flag) => { 
                return state.localization.flags.find(f => f === flag)
            },
            getDisabledToken: (state) => (token) => { 
                return state.localization.disabled_tokens.find(t => t === token)
            },
            getDateFormats: (state) => state.localization.dates,

        }

        this.mutations = {
            setLocalization(state, payload){
                state.localization.terms = payload.terms;
                state.localization.numbers = payload.numbers;
                state.localization.dates = payload.dates;
                state.localization.flags = payload.flags || [];
                state.localization.countries = payload.countries || [];
                state.localization.disabled_tokens = payload.disabled_tokens || [];
            
            },
            setLocaleId(state, payload){
                state.locale_id = payload
            }, 
        
        }
        this.actions = {
            async setLocalizationConfig ({commit}) {
                let filePath;
                try { 
                    const r = await api.get(this.$app, api.LOCALIZATION);
                    console.log(`/files/locales/${r.locale.filename}`,"HIT")
                    if (r?.locale?.filename) {
                        filePath = r?.locale?.filename
                    } else {
                      filePath = 'united_states.json'
                    }
                } catch (error) {
                    filePath = 'united_states.json'
                    console.error('Failed to load localization:', error);
                }
                finally{
                    const response = await fetch(`/files/locales/${filePath}`);
                    const jsonData = await response.json();
                    commit('setLocalization', jsonData);
                }
            },
   
        
        }
   
    }
}

export default Localization;
